(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-media-desktop"] && !Shopify.designMode) return;
  try {
    (() => {
  const install = async () => {
    await customElements.whenDefined('product-image-zoom');
    const label = document.querySelector('[data-isha-zoom-label]')?.textContent.trim() || 'Zoom';
    document.querySelectorAll('.product__media').forEach(gallery => {
      const viewer = gallery.querySelector('product-image-zoom');
      if (!viewer) return;
      viewer.setAttribute('aria-label', label);
      viewer.classList.add('isha-zoom-viewer');
      if (!viewer.hasAttribute('data-isha-detail-zoom')) {
        viewer.setAttribute('data-isha-detail-zoom', '');
        const openViewer = viewer._openPhotoSwipe.bind(viewer);
        viewer._openPhotoSwipe = async () => {
          viewer.maxSpreadZoom = 6;
          await openViewer();
          const ps = viewer.photoSwipeInstance;
          if (!ps || !viewer.hasAttribute('open')) return;
          viewer.querySelector('.isha-zoom-tools')?.remove();
          const toolbar = document.createElement('div');
          toolbar.className = 'isha-zoom-tools';
          toolbar.setAttribute('role', 'group');
          toolbar.setAttribute('aria-label', 'Image zoom controls');
          toolbar.innerHTML = '<button type="button" data-zoom-out aria-label="Zoom out">−</button><output aria-label="Zoom level">100%</output><button type="button" data-zoom-in aria-label="Zoom in">+</button><button type="button" data-zoom-reset aria-label="Reset zoom">Reset</button>';
          viewer.querySelector('.pswp__ui').append(toolbar);
          const minus = toolbar.querySelector('[data-zoom-out]');
          const plus = toolbar.querySelector('[data-zoom-in]');
          const output = toolbar.querySelector('output');
          const limits = () => ({ min: ps.currItem.initialZoomLevel, max: ps.currItem.initialZoomLevel * 6 });
          const setZoom = direction => {
            const { min, max } = limits();
            const target = direction === 0 ? min : Math.max(min, Math.min(max, ps.getZoomLevel() * (direction > 0 ? 1.5 : 1 / 1.5)));
            ps.zoomTo(target, { x: window.innerWidth / 2, y: window.innerHeight / 2 }, 180);
          };
          toolbar.addEventListener('click', event => {
            event.stopPropagation();
            if (event.target.closest('[data-zoom-in]')) setZoom(1);
            if (event.target.closest('[data-zoom-out]')) setZoom(-1);
            if (event.target.closest('[data-zoom-reset]')) setZoom(0);
          });
          const changeLimit = () => { ps.options.maxSpreadZoom = limits().max; };
          ps.listen('afterChange', changeLimit);
          changeLimit();
          let frame;
          const update = () => {
            const { min, max } = limits();
            const zoom = ps.getZoomLevel();
            const text = Math.round(zoom / min * 100) + '%';
            if (output.textContent !== text) output.textContent = text;
            minus.disabled = zoom <= min + .01;
            plus.disabled = zoom >= max - .01;
            frame = requestAnimationFrame(update);
          };
          update();
          ps.listen('close', () => { cancelAnimationFrame(frame); toolbar.remove(); });
        };
      }
      gallery.querySelectorAll('.product__media-item[data-media-type="image"] .product__media-image-wrapper').forEach(wrapper => {
        if (wrapper.hasAttribute('data-isha-zoom-ready')) return;
        wrapper.setAttribute('data-isha-zoom-ready', '');
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'isha-image-zoom-trigger';
        button.setAttribute('aria-label', label);
        button.setAttribute('aria-haspopup', 'dialog');
        button.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><circle cx="10" cy="10" r="6.5"/><path d="m15 15 5 5M10 7v6M7 10h6"/></svg>';
        wrapper.append(button);
        let origin = null;
        wrapper.addEventListener('pointerdown', event => { origin = { x: event.clientX, y: event.clientY }; }, { passive: true });
        wrapper.addEventListener('click', async event => {
          if (origin && event.detail && Math.hypot(event.clientX - origin.x, event.clientY - origin.y) > 12) { origin = null; return; }
          origin = null;
          if (viewer.hasAttribute('open')) return;
          event.preventDefault();
          event.stopPropagation();
          const media = wrapper.closest('[data-media-id]');
          gallery.querySelectorAll('.product__media-item').forEach(item => item.classList.toggle('is-selected', item === media));
          await customElements.whenDefined('product-image-zoom');
          viewer.setAttribute('open', '');
          viewer.focus({ preventScroll: true });
          const observer = new MutationObserver(() => {
            if (!viewer.hasAttribute('open')) { observer.disconnect(); button.focus({ preventScroll: true }); }
          });
          observer.observe(viewer, { attributes: true, attributeFilter: ['open'] });
        });
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', install, { once: true });
  else install();
  document.addEventListener('shopify:section:load', install);
})();
  } catch(e) { console.error(e); }
})();

})();
